import { gqlTagGira } from '@atlassian/jira-apollo-gira';

export const STATUS_CATEGORY_FRAGMENT = gqlTagGira`
    fragment jiraStatusCategoryFragment on JiraStatusCategoryField {
        fieldId
        fieldConfig {
          isEditable
        }
        statusCategory {
          id
          statusCategoryId
          name
        }
    }
`;
